import { Component, OnInit } from '@angular/core';
import {BusinessUnitModel} from '../../../@models';
import {ApiService} from '../../../@core/service/api.service';
import {lastValueFrom, Subscription} from 'rxjs';
import {NbToastrService} from '@nebular/theme';
import { SharedDataService } from '../../../@core/service/shared-data.service';

@Component({
  selector: 'ngx-administration-business-units',
  templateUrl: './administration-business-unit.component.html',
  styleUrls: ['./administration-business-unit.component.scss'],
})
export class AdministrationBusinessUnitComponent implements OnInit {

  constructor(private api: ApiService, public data: SharedDataService, private toastrService: NbToastrService) {
  }

  async ngOnInit() {
    await this.data.loadBusinessUnits();
  }

  save(bu: BusinessUnitModel) {
    const scr = this.api.saveBusinessUnit(bu).subscribe(b => {
      this.toastrService.success("Business unit successfully saved", b.name);
      this.data.reloadBusinessUnits();
      scr.unsubscribe();
    })
  }

}
